import { render } from "./SubscriptionsWidget.vue?vue&type=template&id=6ae2518a&scoped=true&ts=true"
import script from "./SubscriptionsWidget.vue?vue&type=script&lang=ts"
export * from "./SubscriptionsWidget.vue?vue&type=script&lang=ts"

import "./SubscriptionsWidget.vue?vue&type=style&index=0&id=6ae2518a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae2518a"]])

export default __exports__